// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__q2d__ primitives_bodyShort1__Wi_kO","menuItem":"styles_menuItem__jb2b0 primitives_bodyShort1__Wi_kO","iconWrapper":"styles_iconWrapper__n6Ya2"};